"use client";
import React, { useState, useEffect } from "react";
import styles from "./ChatHeader.module.scss";
import Logo from "@/app/icons/logo.svg";
import SvgExit from "@/app/icons/SvgExit.svg";
import { Modal } from "@douyinfe/semi-ui";
import { useTranslations } from "@/app/lib/LocaleProvider";
import SemiButton from "@/app/ui/button";
import { webSocketService } from "@/app/services/WebSocketService";
import { MANUAL_CLOSE_CODE } from "@/app/constants";
import { isHandyApp } from "@/app/utils/device";
import { closeConversation } from "@/app/api/message";
import { useAuth } from "@/app/lib/AuthProvider";
import Link from "next/link";
import { getLang } from "@/app/locales";

export default function ChatHeader() {
  const Locale = useTranslations();
  const { isAuthenticated, user, login, logout } = useAuth();
  const [visible, setVisible] = useState(false);
  const [mounted, setMounted] = useState(false);

  // 等待客户端挂载完成后再显示标题，避免 hydration 错误
  useEffect(() => {
    setMounted(true);
  }, []);

  const handleCancel = () => {
    setVisible(false);
  };

  const getLinkAddress = () => {
    const currentLang = getLang();
    if (currentLang === "en-US") {
      return "https://bambulab.com/en";
    }
    return "https://bambulab.cn/zh-cn";
  };

  const handleOk = async () => {
    if (isAuthenticated) {
      // 已登录用户：关闭会话并登出
      try {
        await closeConversation();
      } catch (error) {
        console.error("Failed to close conversation:", error);
      }
      webSocketService.closeConnection(MANUAL_CLOSE_CODE);
      logout();
    }
    setVisible(false);
  };

  return (
    <div className={styles.header}>
      <Link className={styles.link} href={getLinkAddress()} target="_blank">
        <Logo width={38} height={38} />
      </Link>
      <div className={styles.titleWrapper}>
        <Link href={getLinkAddress()} target="_blank">
          <span className={styles.title}>
            {mounted ? Locale.header.robot : ""}
          </span>
        </Link>
        {/* <span className={styles.desc}>{Locale.header.robotDesc}</span> */}
      </div>

      {/* 用户信息/登录按钮 */}
      <div
        style={{
          marginLeft: "auto",
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        {/* {isAuthenticated ? (
          <>
            {user && (
              <span style={{ fontSize: "14px", color: "white" }}>
                {user.name || user.email || "用户"}
              </span>
            )}
          </>
        ) : (
          <SemiButton
            size="small"
            onClick={login}
            style={{ background: "white", color: "#333" }}
          >
            登录
          </SemiButton>
        )} */}

        {/* 语言切换器 */}
        {/* <LanguageSwitcherButton /> */}

        {/* 退出按钮 */}
        {!isHandyApp() && isAuthenticated && (
          <SvgExit
            className={styles.exit}
            onClick={() => {
              setVisible(true);
            }}
          />
        )}
      </div>

      <Modal
        title={Locale.chatBar.tips}
        visible={visible}
        onCancel={handleCancel}
        closeButtonAutoFocus={false}
        size="small"
        width={300}
        centered
        footer={
          <SemiButton onClick={handleOk}>{Locale.button.confirm}</SemiButton>
        }
      >
        {isAuthenticated ? Locale.chatBar.confirmExit : "确认退出吗？"}
      </Modal>
    </div>
  );
}
